import { z } from "zod";

export const notificationCreated = z.object({
  type: z.literal("NotificationCreated"),
  notificationId: z.string().min(1),
  recipientUserId: z.string().min(1),
  siteId: z.string().nullable().optional(),
  kind: z.string().min(1), // compliance_alert | daily_report | ...
  title: z.string(),
  body: z.string(),
  action: z.string().nullable().optional(),
  entityType: z.string().nullable().optional(),
  entityId: z.string().nullable().optional(),
  payload: z.record(z.string(), z.unknown()).nullable().optional(),
});

export const notificationRead = z.object({
  type: z.literal("NotificationRead"),
  notificationId: z.string().min(1),
  readAt: z.date(),
});

export const notificationEvents = [
  notificationCreated,
  notificationRead,
] as const;
